import React, { Component, Fragment } from 'react';
import { Link, NavLink } from "react-router-dom";
import ChampagneRoom from '../ChampagneRoom/ChampagneRoom';
import PageWrapper from '../PageWrapper/PageWrapper';
import GifBrowser from '../GifBrowser/GifBrowser';
import Modal from '../Modal/Modal';
import VIPModal from '../VIPModal/VIPModal';
import './Home.scss';

import DATA from "../../_gifs.js";

class Home extends Component { 
    constructor(props) {
        super(props);   
        this.state = {
            layout : 'view_headline', // view_headline, view_quilt
            showVIP : false,
            vip : false,
            row : null,
            gif : null
        }    
    }
    componentDidMount () {
        this.handleHash();
        this.VIPCheck();
    }
    VIPCheck = () => {
        // is klue chrome extension installed and open
        const targetNode = document.getElementsByTagName('body')[0];
        
        // Callback function to execute when mutations are observed
        const callback = function(mutationsList, observer) {
            // Use traditional 'for loops' for IE 11
            for(let mutation of mutationsList) {
                if (mutation.type === 'childList') {
                    //alert('A child node has been added or removed.');
                }
                else if (mutation.type === 'attributes') {
                    //alert('The ' + mutation.attributeName + ' attribute was modified.');
                    if (targetNode.classList.contains("highlighter-wrapper")) {
                        observer.disconnect();
                        this.setState({
                            vip : true,
                            showVIP : true
                        })
                    }
                }
            }
        }.bind(this);
        const observer = new MutationObserver(callback);
        observer.observe(targetNode, { attributes: true });
    }
    handleHash = () => {
        let _gif, _row = null;
        
        if (this.props.location.hash) {
            // we got a hot link, ppl
            _gif = this.props.location.hash.split('/')[2];
            _row = this.props.location.hash.split('/')[1];
            // sub foldered GIF 
            if (this.props.location.hash.split('/')[3]) {
                _gif = _gif + "/" + this.props.location.hash.split('/')[3]
            }
            
            this.handleModal(_row, _gif);
        }

        this.setState({
            row : _row,
            gif : _gif
        })
    }
            
    handleLayout = (layout) => {
        this.setState({
            layout : layout
        })
    }
    handleShowVIP = () => {
        this.setState({
            showVIP : !this.state.showVIP
        })
    }
    handleClose = (el) => {
        this.props.history.push(`/`);
        this.setState({
            modal : false
        })
    }
    handleModal = (row, gif) => {
        this.setState({
            modal : true,
            row, gif
        });
    }
    render () {
        let _row = this.state.row,
           _gif = this.state.gif,
           _vip = this.state.vip;
        return (
            <div class="Home">
                { this.state.modal &&
                    <Fragment>
                    {_vip &&
                        <VIPModal gif={ _gif } handleClose={ this.handleClose } />
                    }
                    {!_vip &&
                        <Modal gif={ _gif } handleShowVIP={ this.handleShowVIP } handleClose={ this.handleClose } />
                    }
                    </Fragment>
                }
                <PageWrapper>
                    <header>
                        <Link to="/">
                            {!_vip &&
                                <img src="/assets/img/abg.logo.001.png" />}
                            {_vip &&
                                <img src="/assets/img/vip.001.png" />}
                        </Link>
                    </header>
                    <div class="Home--ui">
                        {_vip &&
                            <ul class="Home--ui--menu">
                                <li class="Home--ui--menu--VIP--on">VIP Access</li>
                                <li class="Home--ui--menu--VIP--indicator">star</li>
                            </ul>
                        }
                        {!_vip && 
                            <ul class="Home--ui--menu">
                                <li>Go VIP?</li>
                                <li 
                                    onClick={ this.handleShowVIP }
                                    class={ this.state.vip ? 'Home--ui--menu--vip on' : 'Home--ui--menu--vip off'}></li>
                            </ul>
                        }
                        <ul class="Home--ui--menu">
                            <li>Layout</li>
                            {['view_headline', 'view_quilt'].map( layout => 
                                 <li 
                                    onClick={ () => this.handleLayout(layout) }
                                    class={ layout === this.state.layout ? 'on' : 'off' }>{ layout }</li>
                            )}
                        </ul>
                    </div>
                    { this.state.showVIP &&
                        <ChampagneRoom  
                            vip={ _vip }
                            layout={ this.state.layout } 
                            gif={ _gif } 
                            row={ _row } 
                            history={ this.props.history } 
                            location={ this.props.location } 
                            handleModal={ this.handleModal }
                            handleShowVIP={ this.handleShowVIP }
                        />
                    }
                    <GifBrowser 
                        vip={ _vip }
                        data={ DATA } 
                        layout={ this.state.layout } 
                        gif={ _gif } row={ _row } 
                        history={ this.props.history } 
                        location={ this.props.location }
                        handleModal={ this.handleModal }
                    />
                    <footer>
                        <div>
                            <Link to="/klue"><img src="/assets/img/ex-klu-sive.png"/></Link>
                        </div>
                        <p>&copy; 2020 In hindsight. All rights reserved &mdash; Klue Labs Inc.</p>
                    </footer>
                </PageWrapper>
            </div>
        )
    }
}
export default Home;